<template>
  <el-dialog
    title="地址管理"
    :visible.sync="dialogVisible"
    width="650px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :destroy-on-close="true"
    :before-close="handleClose">
    <div>
      <span>原始地址：</span>
      <span>{{ order.receiver_name }}，</span>
      <span>{{ order.receiver_phone }}，</span>
      <span>{{ order.receiver_province }}</span>
      <span class="ml-5">{{ order.receiver_city }}</span>
      <span class="ml-5">{{ order.receiver_district }}</span>
      <span class="ml-5">{{ order.receiver_place }}</span>
    </div>
    <rs-form ref="form" :model="formData" :errors="formErrors" :rules="rules" label-width="90px" class="mt-20">
      <el-form-item label="收货人" prop="receiver_name">
        <el-input v-model="formData.receiver_name"></el-input>
      </el-form-item>
      <el-form-item label="联系方式" prop="receiver_phone">
        <el-input v-model="formData.receiver_phone"></el-input>
      </el-form-item>
      <el-form-item label="地区" required>
        <el-cascader style="width: 100%" v-if="showAddress" v-model="areas" :props="props"></el-cascader>
      </el-form-item>
      <el-form-item label="地址" prop="receiver_place">
        <el-input v-model="formData.receiver_place"></el-input>
      </el-form-item>
    </rs-form>
    <span slot="footer" class="dialog-footer">
      <el-button plain round class="main-btn" @click="handleClose">
        取 消
      </el-button>
      <el-button round class="main-btn ml-20" type="primary" @click="handleSubmit" :loading="dialogSubmitLoading">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getArea } from '@/api/area.js';
import { updateOrderAddress } from '@/api/order.js';

export default {
  data() {
    return {
      dialogSubmitLoading: false,
      dialogVisible: false,
      areas: [],
      formData: {
        receiver_name: null,
        receiver_phone: null,
        receiver_province: null,
        receiver_city: null,
        receiver_district: null,
        receiver_place: null,
      },
      order: {},
      showAddress: true,
      props: {
        label: 'name',
        lazy: true,
        lazyLoad (node, resolve) {
          const { level } = node;
          let pid = 0;
          if (level > 0) {
            let arr = node.value.split('-')
            pid = arr[0]
          }
          getArea(pid).then(res => {
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            if (pid == 0) {
              resolve(res.map(item => {
                item.value = item.id + '-' + item.name
                return item
              }));
            } else {
              resolve(res.subs.map(item => {
                item.leaf = (level > 1)
                item.value = item.id + '-' + item.name
                return item;
              }));
            }
          });
        }
      },
      rules: {
        receiver_name: [
          { required: true, message: '收货人不能为空', trigger: 'blur' },
          { min: 2, max: 30, message: '收货人长度在 2 到 16 个字符之间', trigger: 'blur' }
        ],
        receiver_phone: [
          { required: true, message: '联系方式不能为空', trigger: 'blur' },
          { min: 8, max: 11, message: '收货人长度在 8 到 11 个字符之间', trigger: 'blur' }
        ],
        receiver_place: [
          { required: true, message: '地址不能为空', trigger: 'blur' }
        ],
      },
      error: {},
      formErrors: []
    }
  },
  methods: {
    show(order) {
      this.dialogVisible = true;
      this.order = order
      this.formData.receiver_name = order.receiver_name
      this.formData.receiver_phone = order.receiver_phone
      this.formData.receiver_place = order.receiver_place
    },
    handleClose() {
      this.dialogVisible = false;
      this.formData = {};
      this.$nextTick(() => {
        this.$refs['form'].resetFields();
      });
    },
    handleSubmit() {
      this.$refs['form'].validate((valid) => {
        if (!valid) return false;

        this.formData.receiver_province = this.areas[0].split('-')[1];
        this.formData.receiver_city = this.areas[1].split('-')[1];
        this.formData.receiver_district = this.areas[2].split('-')[1];

        this.dialogSubmitLoading = true;
          updateOrderAddress(this.order.order_id, this.formData).then(() => {
            this.$emit('on-success')
            this.dialogVisible = false;
            this.dialogSubmitLoading = false;
          }).catch(err => {
            this.formErrors = err.data || [];
            this.dialogSubmitLoading = false;
          })
      });
    },
  }
}
</script>